/**
 * results.js — Single source of truth for all event result data.
 *
 * This file is derived from results.csv in the same folder.
 * To update numbers site-wide, edit results.csv then paste the updated
 * array here using the same structure. All three consumers will reflect
 * the change automatically on next build:
 *
 *   1. Scrolling ticker       → App.jsx         (tickerResults)
 *   2. Home page result cards → HomePage.jsx    (homeResults)
 *   3. Results page grid      → EventResultsPage.jsx (eventResults)
 */

export const eventResults = [
  {
    location: 'Tampa',
    state: 'FL',
    category: 'automotive',
    eventType: 'Off-Site Sales Event',
    duration: '5 Days',
    appointments: 227,
    units: 62,
    gross: 376000,
    testimonial: "THE BEST event we've ever run. Professional team, real results!",
    dealer: 'General Manager, Tampa, FL',
  },
  {
    location: 'Dallas',
    state: 'TX',
    category: 'automotive',
    eventType: 'Direct Mail & Facebook Event',
    duration: '7 Days',
    appointments: 156,
    units: 84,
    gross: 457000,
    testimonial: "Driven2WIN is hands-down the best event company I've worked with.",
    dealer: 'Owner, Dallas, TX',
  },
  {
    location: 'Phoenix',
    state: 'AZ',
    category: 'motorcycle',
    eventType: 'Motorsports Event',
    duration: '10 Days',
    appointments: 118,
    units: 76,
    gross: 423000,
    testimonial: 'The TURNOUT was incredible. Customers were ready to buy!',
    dealer: 'Sales Director, Phoenix, AZ',
  },
  {
    location: 'Charlotte',
    state: 'NC',
    category: 'automotive',
    eventType: 'Direct Mail & Facebook Event',
    duration: '5 Days',
    appointments: 98,
    units: 59,
    gross: 367000,
  },
  {
    location: 'Denver',
    state: 'CO',
    category: 'automotive',
    eventType: 'Off-Site Sales Event',
    duration: '5 Days',
    appointments: 104,
    units: 57,
    gross: 345000,
  },
  {
    location: 'Atlanta',
    state: 'GA',
    category: 'automotive',
    eventType: 'Direct Mail Campaign',
    duration: '5 Days',
    appointments: 112,
    units: 68,
    gross: 386000,
  },
  {
    location: 'Houston',
    state: 'TX',
    category: 'automotive',
    eventType: 'Direct Mail & Facebook Event',
    duration: '6 Days',
    appointments: 134,
    units: 77,
    gross: 437000,
  },
  {
    location: 'Orlando',
    state: 'FL',
    category: 'golf-cart',
    eventType: 'Golf Cart Sales Event',
    duration: '4 Days',
    appointments: 89,
    units: 49,
    gross: 296000,
    testimonial: 'Reached retirement communities we had never tapped before. Incredible response!',
    dealer: 'Owner, Orlando, FL',
  },
  {
    location: 'Scottsdale',
    state: 'AZ',
    category: 'golf-cart',
    eventType: 'Golf Cart Community Event',
    duration: '4 Days',
    appointments: 58,
    units: 43,
    gross: 268000,
    testimonial: 'Best sales weekend in our company history. Direct mail targeting was spot-on.',
    dealer: 'Owner, Scottsdale, AZ',
  },
  {
    location: 'Baton Rouge',
    state: 'LA',
    category: 'golf-cart',
    eventType: 'Golf Cart Sales Event',
    duration: '3 Days',
    appointments: 54,
    units: 41,
    gross: 255000,
    testimonial: 'Sold 41 carts over a long weekend — our best event ever.',
    dealer: 'General Manager, Baton Rouge, LA',
  },
  {
    location: 'San Diego',
    state: 'CA',
    category: 'rv',
    eventType: 'RV Expo Event',
    duration: '3 Days',
    appointments: 76,
    units: 41,
    gross: 823000,
  },
  {
    location: 'Nashville',
    state: 'TN',
    category: 'automotive',
    eventType: 'Direct Mail & Facebook Event',
    duration: '5 Days',
    appointments: 118,
    units: 66,
    gross: 378000,
  },
  {
    location: 'Seattle',
    state: 'WA',
    category: 'automotive',
    eventType: 'Direct Mail & Facebook Event',
    duration: '10 Days',
    appointments: 93,
    units: 72,
    gross: 467000,
  },
  {
    location: 'Miami',
    state: 'FL',
    category: 'automotive',
    eventType: 'Direct Mail + Social Media',
    duration: '6 Days',
    appointments: 141,
    units: 72,
    gross: 419000,
  },
  {
    location: 'Kansas City',
    state: 'MO',
    category: 'automotive',
    eventType: 'Tent Event + Direct Mail',
    duration: '5 Days',
    appointments: 106,
    units: 81,
    gross: 478000,
  },
];

/**
 * Ticker — shown in the scrolling banner on every page.
 * Includes all results (incl. Kansas City which isn't on the Results grid).
 */
export const tickerResults = eventResults.map(r => ({
  location: `${r.location}, ${r.state}`,
  units: r.units,
  gross: r.gross,
}));

/**
 * Home page result cards — top 8 automotive/motorcycle/rv results by gross.
 * Golf cart entries excluded from home cards (different sales scale).
 */
export const homeResults = eventResults
  .filter(r => r.category !== 'golf-cart')
  .sort((a, b) => b.gross - a.gross)
  .slice(0, 8)
  .map(r => ({
    location: `${r.location}, ${r.state}`,
    units: r.units,
    gross: r.gross,
  }));
